import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";
import topText1 from "../../images/Text_Background_for_all_pages.png";
import topText2 from "../../images/Text_Background_for_all_pages_2.png";
import topText3 from "../../images/Text_Background_for_all_pages_3.png";


const StyledDiv = styled.div`
	

	.topBanner {
		width: 100%;
		height: 65vh;
        background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
		font-weight: normal;
	}

    .topTitle{
        position: absolute;
		font-size: 75px;
		top: 38%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: normal;
    }

	.topText {
		width: 100%;
		margin-top: -5px;
		height: 45vh;
		position: relative;
		font-weight: normal;
	

		
		

		.sub-text {
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
			font-family: "nexa-bold";
			background-clip: text;
			font-weight: 900;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 1;
			width: 70%;
			font-size: 60px;
			line-height: .95;
			font-weight: 300;
		}

		.texts{
			-webkit-text-fill-color: white;
		}
	}

	@media screen and ${breakpoints.device.laptop} {

		.topBanner {
			
			height: 25vh;
		}
	
		.topText {			
			height: 30vh;	
		}

	}

	@media screen and ${breakpoints.device.tablet} {

	

	 .topTitle{
		font-size: 35px;	
		top: 32%;
	 }
		

	
		.topText {
			height: 22vh;
			.sub-text {
				font-size: 30px;
				padding: 20px 0;
				width: 85%;
				line-height: 7vw;
			}
		}

		.section-btn {
			font-size: 4vw;
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		min-height: 30vh;

		.topText {
			.sub-text {
				font-size: 30px;
				padding: 25px 0;
				width: 85%;
				line-height: 7vw;
				margin: 25px 0;
			}
		}

		.section-btn {
			font-size: 4vw;
		}
	}
`;

const NewTopBanner = ({ bg, txt, logo, btn, video, title }) => {

      const divStyle = window.innerWidth > 750 ? {
            backgroundImage: `linear-gradient(180deg, rgba(137, 208, 194, 0.85) 0%, rgba(68, 178, 221, 0.85) 100%), url(${bg})`,
            backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '50vh',
			position: 'relative'
        } : {
            backgroundImage: `linear-gradient(180deg, rgba(137, 208, 194, 0.85) 0%, rgba(68, 178, 221, 0.85) 100%), url(${bg})`,
            backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '15vh',
			position: 'relative'
        } ;

	return (
		<StyledDiv className="banner">
            <div style={divStyle}>
                <h2 className="topTitle">{title}</h2>
            </div>
			{txt != null ? <div className="topText">
				<p className="sub-text">
					{txt}
					<br />
					{btn}
				</p>
				
			</div> : <></>}
			
		</StyledDiv>
	);
};

export default NewTopBanner;
